/**
 * EditorPreview -- 청첩장 실시간 프리뷰
 *
 * 폰 프레임 래퍼만 담당하고, 실제 청첩장 렌더링은 템플릿 컴포넌트에 위임.
 */

import type { SectionId, TemplateConfig } from '@cugumi/shared/schemas'
import { DEFAULT_TEMPLATE_CONFIG } from '@cugumi/shared/schemas'
import type { FlatInvitation } from '../../stores/invitationStore.js'
import { getTemplateComponent } from '../templates/index.js'
import styles from './EditorPreview.module.css'

interface EditorPreviewProps {
  invitation: FlatInvitation
  activeSection?: SectionId | null
  onSectionClick?: (sectionId: SectionId) => void
  templateConfig?: TemplateConfig
}

export function EditorPreview({ invitation, activeSection, onSectionClick, templateConfig }: EditorPreviewProps) {
  const config = templateConfig ?? DEFAULT_TEMPLATE_CONFIG
  const TemplateComponent = getTemplateComponent(config.componentId)

  return (
    <div className={styles.wrapper}>
      <div className={styles.phone}>
        <div className={styles.screen}>
          <TemplateComponent
            invitation={invitation}
            config={config}
            activeSection={activeSection}
            onSectionClick={onSectionClick}
            mode="editor"
          />
        </div>
      </div>
    </div>
  )
}
